import { useState } from 'react';
import { Button, Divider, Icon, Sheet } from '@gravity-ui/uikit';
import { ChevronRight, CircleInfo, Xmark } from '@gravity-ui/icons';
import { InfoCard } from 'features/ui-kit/info-card';
import { getGenderTypeText, getSpokesmanTypeText, yearToDisplayText } from 'features/utils';
import type { Blank } from 'store/types/common';

import {
	ADDITIONAL_INFORMATION,
	BIRTH_YEAR,
	CLIENT_INFO,
	CLIENT_REQUEST,
	DIAGNOSIS,
	GENDER,
	INSTITUTION,
	QUESTIONS,
	USER_AGREEMENT,
	VIOLATIONS,
} from '../constants';
import { ClientAgreement } from '../utils';

import styles from './styles.module.scss';

interface ClientInfoProps {
	data: Blank;
}

export const ClientInfoSheet = ({ data }: ClientInfoProps) => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<Button size="xl" view="outlined" onClick={() => setOpen(true)} className={styles.sheet_btn_open}>
				<Icon data={CircleInfo} size={20} />
				{CLIENT_INFO}
				<Icon data={ChevronRight} size={20} />
			</Button>
			<Sheet visible={open} onClose={() => setOpen(false)} className={styles.sheet}>
				<div className={styles.info}>
					<div className={styles.info__close}>
						<h3 className={styles.info__title}>{CLIENT_INFO}</h3>
						<Button onClick={() => setOpen(false)} view="flat">
							<Icon data={Xmark} size={16} />
						</Button>
					</div>

					<InfoCard
						className={styles.info__card}
						values={[
							[BIRTH_YEAR, yearToDisplayText(new Date(data.birthday))],
							[GENDER, getGenderTypeText(data.gender)],
							[INSTITUTION, data.establishment?.name ? data.establishment.name : undefined],
							[QUESTIONS, getSpokesmanTypeText(data.spokesman)],
							[VIOLATIONS, data.violations],
						]}
					/>

					<Divider />

					<InfoCard
						className={styles.info__card}
						values={[
							[DIAGNOSIS, data.diagnosis],
							[ADDITIONAL_INFORMATION, data.additionalInformation],
							[CLIENT_REQUEST, data.customerRequest],
						]}
					/>

					<Divider />

					<InfoCard
						values={[
							// eslint-disable-next-line react/jsx-key
							[USER_AGREEMENT, <ClientAgreement value={data.consent} />], // Пользовательское соглашение
						]}
					/>
				</div>
			</Sheet>
		</>
	);
};
